import { render } from "./wkSimpleChat.vue?vue&type=template&id=b180aefa&scoped=true"
import script from "./wkSimpleChat.vue?vue&type=script&lang=js"
export * from "./wkSimpleChat.vue?vue&type=script&lang=js"

import "./wkSimpleChat.vue?vue&type=style&index=0&id=b180aefa&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b180aefa"]])

export default __exports__